/* eslint-disable no-undef */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { createResource, saveResource, getTemplate, getResourceFormatChain } from 'actions/resourceActions';
import { actionError } from 'helpers/actionHelpers';

import CreateResourceButton from 'field/edit/resource/CreateResourceButton';
import ResourceLinkEdit from 'field/edit/resource/ResourceLinkEdit';
import EditLinkedResources from 'field/edit/resource/EditLinkedResources';

const ProceduralUnitsEdit = (props) => {
  const folder = useSelector(state => state.object.museum);
  const state = useSelector(state => state);
  const { field, createResource, actionError, getTemplate } = props;
  const predicate = field.predicate;
  const type = field.props.proceduralUnitsSearch || '';
  const view = 'ProceduralUnits';
  const objectUri = useSelector(state => state.object.uri);
  const resources = useSelector(state => state.modal.resources);
  const removeProcUnit = useSelector(state => state.view.view.props.removeProcedularUnitFields);
  const procedularUnitFolder = useSelector(state => state.view.view.props.procedularUnitFolder);
  const currentView = useSelector(state => state.view.view.view);

  const resourceFormatChain = getResourceFormatChain(resources, resourceFormatChain);

  // Set procedureTitle to filter type of procedure by default
  const searchParameters = {
    constraint: 'ProceduralUnits->' + folder,
    searchView: view,
    execute: true,
    topLevel: 'procedureTitleTop',
    searchKey:  'select_procedureTitle_1',
    searchValue:    `http://www.profium.com/spectrum/ProcedureTitleList#${type}`,
    searchOperation:    'new',
  };

  const onCreate = () => {
    createResource({
      predicate,
      onSave: resource => {
        // Setting folder before saving -> saved as ArchivedObject
        resource.folder = folder ? folder : addFolderIfMassEdit(removeProcUnit, currentView, procedularUnitFolder);
        resource.view = view;
        saveResource(resource, objectUri, view, resourceFormatChain)
          .then(({ value }) => field.addValue(value))
          .catch(e => actionError(e));
      }
    });
    // add template for ArchivedObject (templateItem)
    getTemplate();
  };

  return (
    <div className="field">
      <CreateResourceButton
        onCreate={onCreate}
        label={field.label} />
      <ResourceLinkEdit searchParameters={searchParameters} {...props} />
      <EditLinkedResources
        onEdit={field.editResource}
        onRemove={field.removeResource}
        values={field.values} />
    </div>
  );
};

const addFolderIfMassEdit = (removeProcUnit, currentView, procedularUnitFolder) => {
  if (currentView === 'mass-edit' && removeProcUnit === 'false') {
    return procedularUnitFolder;
  }
  return null;
}

export default connect(null, { createResource, getTemplate })(ProceduralUnitsEdit);